import register from 'ShopUiBundle/modules/app/registry';
import './trbo-slider.scss';

// tslint:disable-next-line
register('trbo-slider', () => import(/* webpackMode: "lazy" */'./trbo-slider'));
